import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/libs/vant-ui'
import { Toast, NoticeBar, Swipe, SwipeItem, Area, Popover, AddressEdit, CountDown } from 'vant'
import 'swiper/css/swiper.css'
import LuckDraw from 'vue-luck-draw'
import VueLuckyCanvas from '@lucky-canvas/vue'
Vue.use(VueLuckyCanvas)
Vue.use(LuckDraw)
Vue.use(Area)
Vue.use(AddressEdit)
Vue.use(CountDown)
// import 'swiper/swiper-bundle.css'
Vue.config.productionTip = false
Vue.prototype.$eventBus = new Vue()
Vue.use(NoticeBar)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Toast)
Vue.use(Popover)

Vue.mixin({
    data () {
        return {
            toast1: null
        }
    },
    methods: {
        openLoading () {
            this.toast1 = Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: '加载中'
            })
        },
        closeLoading () {
            this.toast1.clear()
        }
    }
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
